import React from 'react'
import 'react-vis/dist/style.css'
import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN7011', nightvision: 12, megapixel: 1, power: 8, focal: 6, irleds: 22 },
  { name: 'IN2905', nightvision: 15, megapixel: 0.3, power: 5.8, focal: 6, irleds: 24 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focal', domain: [5, 6] },
              { name: 'megapixel', domain: [0, 1] },
              { name: 'power', domain: [5, 8] },
              { name: 'nightvision', domain: [11, 15] },
              { name: 'irleds', domain: [21, 24] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}